
// Données structurées pour l'organisation principale
export const getOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.groupefabre-environnement.fr/#organization",
    "name": "Groupe Fabre Environnement",
    "alternateName": ["Groupe Fabre", "Fabre Environnement"],
    "url": "https://www.groupefabre-environnement.fr/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://lovable.dev/opengraph-image-p98pqg.png",
      "width": 1200,
      "height": 630,
      "caption": "Logo Groupe Fabre Environnement"
    },
    "image": [
      {
        "@type": "ImageObject",
        "url": "https://lovable.dev/opengraph-image-p98pqg.png",
        "width": 1200,
        "height": 630
      }
    ],
    "description": "Spécialiste de la gestion, collecte et valorisation des déchets depuis plus de 25 ans en Occitanie. Solutions professionnelles pour particuliers, entreprises et collectivités.",
    "foundingDate": "1998",
    "numberOfEmployees": {
      "@type": "QuantitativeValue",
      "value": "50-100"
    },
    "slogan": "Votre partenaire pour une gestion responsable des déchets",
    "keywords": [
      "recyclage",
      "déchets",
      "valorisation",
      "métaux",
      "bennes",
      "environnement",
      "démolition",
      "collecte",
      "tri sélectif",
      "économie circulaire"
    ],
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+33565787900",
        "contactType": "customer service",
        "availableLanguage": ["French"],
        "areaServed": "FR-OCC",
        "contactOption": "TollFree",
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "17:00"
        }
      },
      {
        "@type": "ContactPoint",
        "email": "contactgfe@groupefabre.com",
        "contactType": "customer service",
        "availableLanguage": ["French"]
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Zone Industrielle de Cantaranne",
      "addressLocality": "Rodez",
      "postalCode": "12000",
      "addressRegion": "Occitanie",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "44.3500",
      "longitude": "2.5833"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Occitanie",
      "geo": {
        "@type": "GeoShape",
        "box": "42.33 0.61 45.01 4.84"
      }
    },
    "serviceType": [
      "Gestion des déchets",
      "Recyclage",
      "Valorisation",
      "Location de bennes",
      "Achat métaux",
      "Démolition"
    ],
    "sameAs": [
      "https://www.facebook.com/GroupeFabre/",
      "https://www.linkedin.com/company/groupe-fabre/"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de gestion des déchets",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Location de bennes",
            "description": "Location de bennes pour tous types de déchets de 8m³ à 30m³",
            "provider": {
              "@type": "Organization",
              "@id": "https://www.groupefabre-environnement.fr/#organization"
            },
            "areaServed": "FR-OCC"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Achat de métaux",
            "description": "Rachat de métaux ferreux et non ferreux au meilleur prix",
            "provider": {
              "@type": "Organization",
              "@id": "https://www.groupefabre-environnement.fr/#organization"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Démolition",
            "description": "Services de démolition professionnelle et évacuation",
            "provider": {
              "@type": "Organization",
              "@id": "https://www.groupefabre-environnement.fr/#organization"
            }
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Valorisation des déchets",
            "description": "Valorisation et recyclage de tous types de déchets",
            "provider": {
              "@type": "Organization",
              "@id": "https://www.groupefabre-environnement.fr/#organization"
            }
          }
        }
      ]
    },
    "award": [
      "Certifié ISO 14001",
      "Agréé préfecture pour la collecte de déchets"
    ],
    "certification": [
      {
        "@type": "Certification",
        "name": "ISO 14001",
        "description": "Management environnemental"
      }
    ]
  };
};

// Données structurées pour les entreprises locales
export const getLocalBusinessSchema = (locationData?: {
  city?: string;
  region?: string;
  postalCode?: string;
  serviceType?: string;
}) => {
  const baseData = getOrganizationSchema();
  
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `https://www.groupefabre-environnement.fr/#localbusiness-${locationData?.city || 'rodez'}`,
    "name": locationData?.serviceType 
      ? `${baseData.name} - ${locationData.serviceType} ${locationData.city || 'Rodez'}`
      : baseData.name,
    "description": locationData?.serviceType
      ? `Services de ${locationData.serviceType.toLowerCase()} professionnels à ${locationData.city || 'Rodez'}. ${baseData.description}`
      : baseData.description,
    "url": baseData.url,
    "logo": baseData.logo,
    "image": baseData.image,
    "telephone": baseData.contactPoint[0].telephone,
    "email": baseData.contactPoint[1].email,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": locationData?.city || baseData.address.addressLocality,
      "addressRegion": locationData?.region || baseData.address.addressRegion,
      "postalCode": locationData?.postalCode || baseData.address.postalCode,
      "addressCountry": baseData.address.addressCountry
    },
    "geo": baseData.geo,
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "17:00"
      }
    ],
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": baseData.geo,
      "geoRadius": "100000"
    },
    "priceRange": "€€",
    "paymentAccepted": ["Cash", "Credit Card", "Invoice", "Check"],
    "currenciesAccepted": "EUR",
    "hasMap": `https://www.google.com/maps/place/${encodeURIComponent(baseData.address.streetAddress + ', ' + baseData.address.addressLocality)}`,
    "isAccessibleForFree": false,
    "publicAccess": true
  };
};
